<template>
  <component
    v-if="resolvedComponent"
    :is="resolvedComponent"
    v-bind="props"
    @image-register="$emit('image-register', $event)"
    @image-click="$emit('image-click', $event)"
  />
  <div v-else class="component-error">
    <p>Component type "{{ type }}" not found</p>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import ChartDemo from "./ChartDemo.vue";
import AnimatedCounter from "./AnimatedCounter.vue";
import SimpleImage from "../common/SimpleImage.vue";
import KlaviyoForm from "./KlaviyoForm.vue";
import VideoEmbed from "./VideoEmbed.vue";

export default defineComponent({
  name: "DynamicComponent",
  components: {
    ChartDemo,
    AnimatedCounter,
    SimpleImage,
    KlaviyoForm,
    VideoEmbed,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    props: {
      type: Object,
      required: true,
    },
  },
  emits: ["image-register", "image-click"],
  computed: {
    resolvedComponent() {
      console.log("DynamicComponent: Resolving component type:", this.type);

      const componentMap = {
        chart: ChartDemo,
        counter: AnimatedCounter,
        SimpleImage: SimpleImage, // This matches the blog post content
        image: SimpleImage, // Alternative mapping for flexibility
        KlaviyoForm: KlaviyoForm, // Klaviyo form component
        VideoEmbed: VideoEmbed, // Video embed component
      };

      const component = componentMap[this.type];
      console.log("DynamicComponent: Mapped component:", component);

      if (!component) {
        console.warn(`DynamicComponent: Unknown component type "${this.type}"`);
        return null;
      }

      return component;
    },
  },
});
</script>
